import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Toast } from "./toast.interface";

@Component({
  selector: "app-toaster",
  template: `
    <div class="custom-toaster">
      <div
        class="custoast custoast-{{ toast.type }}"
        [style.bottom.px]="i * 100">
        <p class="toast-pera">{{ toast.body }}</p>
        <a class="close" (click)="remove.emit(i)">&times;</a>
      </div>
    </div>
  `,
  styles: [
    `
  .custoast {
    position: relative;
    margin: 0 auto;
    width: 46%;
    height: 48px;
    border: 0px solid transparent;
    border-radius: 0px 0px 38px 38px;
    padding:0px 0px 0px 0px;
    display:table;    
    z-index: 10000;
    animation: move 10s 1;
    animation-direction: alternate;
    outline:none;
  }
  .custom-toaster{
  width: 100%;
  position: fixed;
  z-index: 20000;
  top: -1px;
  max-width: 1920px;
  }
  .toast-pera{
    margin-top:12px;
    font-size:14px;
    text-align: center;
    padding-right:30px;
    padding-left:30px;
    letter-spacing: 1px;
  }
  .custoast-success {
    color: #fff;
    background-color: rgb(53, 210, 101);
    border-color: #c3e6cb;
  }

  .custoast-error {
    color: #fff;
    background-color: #ff4560;
    border-color: #ff4560;
  }

  .custoast-warning {
    color: #fff;
    background-color: #ffc93c;
    border-color: #ffc93c;
  }

  .close {
    position: absolute;
    top: 5px;
    right: 15px;
    font-size: 1.5em;
    cursor: pointer;
    padding: 0px 0px 0px 0px;
    opacity: 0.9;
    color: #fff;
    text-decoration: none;
  }

  .custoast-heading {
    margin-top: 7px;
    margin-left: 80px;
    font-size: 15px;
  }
  .custoast-msg {
    font-size: 13px;
  }
  @keyframes move {
    0% {
       transform: translateY(-100%);
    }
    23.33%, 50% {
      transform: translateY(0);
    }
     73.33%, 100% {
      transform: translateY(-100%);
    }
  }
  @media(max-width: 1200px) {
    .custoast {
      width: 60%;
    }
  }
  @media(max-width: 767px) {
    .custoast {
      width: 96%;
    }
  }
  `,],
})
export class ToasterComponent {
  @Input() toast: Toast;
  @Input() i: number;

  @Output() remove = new EventEmitter<number>();
}
